import React,{useState} from 'react';
import { Col, Row } from 'reactstrap';
import debugLogger from '../../Utils/debugLogger';
import MediaService from '../../../api/services/MediaService';
import moment from "moment";



const MediaComponent = (props) => {
    const [media, setMedia] = useState([]);
    const [data, setData] = useState([]);

    React.useEffect(() => {
        window.scrollTo(0, 0);
        getList();
    }, []);

    const getList = async () => {
        try {
            const res = await MediaService.getMediaList();
            console.debug('[MediaComponent] service result:', res);

            if (res && res.success) {
                const payload = res.data || {};
                const list = Array.isArray(payload) ? payload : (payload.list || []);

                // find the media record whose title matches the prop
                const matched = list.find((item) => (item.title || '') === props.data);
                if (matched) {
                    console.debug('[MediaComponent] matched item:', matched);
                    let mediaDetail = [];
                    try {
                        mediaDetail = typeof matched.mediaList === 'string' ? JSON.parse(matched.mediaList) : (matched.mediaList || []);
                    } catch (parseErr) {
                        console.warn('[MediaComponent] failed to parse mediaList', parseErr, matched.mediaList);
                        mediaDetail = [];
                    }
                    setMedia(mediaDetail);
                } else {
                    console.debug('[MediaComponent] no matched media for title', props.data);
                    setMedia([]);
                }
            } else {
                console.warn('getMediaList: API returned failure or unexpected shape', res);
                setMedia([]);
            }
        } catch (err) {
            console.error('getMediaList error', err);
            setMedia([]);
        }
    }

    return (
        <Row className="mx-0 ">
            {media.length > 0 && media.map((item, index) => {
                return <Col xs={12} sm={12} md={12} lg={12} xl={12}  className="px-0">
                    <Row key={index} className=" mx-0">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="px-0">
                           <a href={`${item.mediaUrl}`} rel="noreferrer" target="_blank" className="h6-medium media-links media-section-title jostRegular align-left media-card-position text-underline">
                                {item.mediaName}</a>
                            <p className="p-small jostRegular align-left media-card-position pt-1">{moment(item.date).format('D MMM yyyy')}</p>
                        </Col>
                    </Row>
                </Col>
            })}
        </Row>
    )
};


export default MediaComponent;
